<template>
  <div
    v-if="visible"
    class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-[9999]"
  >
    <div
      class="flex flex-col items-center justify-center p-6 bg-black bg-opacity-60 rounded-xl"
    >
      <div
        class="mt-2 flex items-center justify-center"
        style="
          animation: spin 2s linear infinite;
          border: 16px solid #f3f3f3;
          border-top: 16px solid #3498db;
          border-radius: 50%;
          width: 60px;
          height: 60px;
        "
      ></div>
      <p class="text-white text-base font-medium">로딩중입니다.</p>
    </div>
  </div>
</template>

<script setup>
import { ref, defineExpose } from "vue";

const visible = ref(false);

function show() {
  visible.value = true;
}

function hide() {
  visible.value = false;
}

defineExpose({ show, hide });
</script>

<style>
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
